import React, { useEffect, useState } from 'react';
import {
  FirstBall,
  FirstHomeRun,
  FirstStrike,
  SpecialWrapper,
  Table,
  TeamName
} from './styled';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

const BaseballBoxScore = observer(({ detail }) => {
  const { teams, special, period } = detail;
  const [viewPeriod, setViewPeriod] = useState(9);
  const homeTeam = teams.home;
  const awayTeam = teams.away;

  useEffect(() => {
    if (period > 9) {
      setViewPeriod(period);
    }
  }, [period]);

  let periodHeadComp = [];
  let periodScoreComp = [];
  for (let num = 1; num <= viewPeriod; num++) {
    periodHeadComp.push(<th key={num}>{num}</th>);
    periodScoreComp.push(<td key={num}>{detail.periodScore[num] || 0}</td>);
  }

  return (
    <Table>
      <colgroup>
        <col width={147} />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          {periodHeadComp}
          <th>R</th>
          <th>H</th>
          <th>E</th>
          <th>B</th>
        </tr>
      </thead>
      <tbody>
        <TeamRow
          teamData={awayTeam}
          position={'AWAY'}
          special={special}
          detail={detail}
          viewPeriod={viewPeriod}
        />
        <TeamRow
          teamData={homeTeam}
          position={'HOME'}
          special={special}
          detail={detail}
          viewPeriod={viewPeriod}
        />
      </tbody>
      <tfoot>
        <tr>
          <th></th>
          {periodScoreComp}
          <td>{detail.summaryScore}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </Table>
  );
});

const TeamRow = ({ teamData, position, detail, viewPeriod }) => {
  const { special } = detail;
  const { periodData, name, baseOnBallCount, errorCount, hitCount } = teamData;
  let totalScore = 0;
  if (position === 'HOME') {
    totalScore = detail.homeTotalScore;
  } else {
    totalScore = detail.awayTotalScore;
  }

  let periodScoreComp = [];
  for (let num = 0; num < viewPeriod; num++) {
    periodScoreComp.push(
      <td key={num}>
        {periodData[num] && periodData[num].score}
        <Special specialData={special} position={position} period={num + 1} />
      </td>
    );
  }

  return (
    <tr>
      <th>
        {name}
        <TeamName position={position} />
      </th>
      {periodScoreComp}
      <td>{totalScore}</td>
      <td>{hitCount}</td>
      <td>{errorCount}</td>
      <td>{baseOnBallCount}</td>
    </tr>
  );
};

const Special = ({ specialData, position, period }) => {
  let specialComps = [];
  if (specialData !== null) {
    const { firstBaseOnBall, firstHomerun, firstStrikeOut } = specialData;
    if (
      firstStrikeOut !== null &&
      firstStrikeOut.location === position &&
      firstStrikeOut.period === period
    ) {
      specialComps.push(<FirstStrike key={'FirstStrike'} />);
    }
    if (
      firstHomerun !== null &&
      firstHomerun.location === position &&
      firstHomerun.period === period
    ) {
      specialComps.push(<FirstHomeRun key={'FirstHomeRun'} />);
    }
    if (
      firstBaseOnBall !== null &&
      firstBaseOnBall.location === position &&
      firstBaseOnBall.period === period
    ) {
      specialComps.push(<FirstBall key={'FirstBall'} />);
    }
  }
  return <SpecialWrapper>{specialComps}</SpecialWrapper>;
};

export default BaseballBoxScore;
